<script>

import * as types from '@/store/mutation-types'
import { WebUtil } from '@/utils/webUtil.js'
import { DateUtil } from '@/utils/dateUtil.js'
import { AjaxUtil } from '@/utils/ajaxUtil.js'
import AxiosUtil    from '@/utils/AxiosUtil.js'
import { SessionUtil } from '@/utils/sessionUtil'
import { type } from 'jquery'

// mixin 객체 생성
const baseMixins = {
    data () {
        return {
            paging: {
                paging        : 'Y',
                pageCount     : 10,
                currentPageNo : 0
            },
        }
    },
    methods: {
           /* 공통 코드 리스트 구하기
        *  cdGrp        : 코드 그룹
        *  arrayObject  : 코드 리스트 넣을 리스트
        *  allAddYn     : 빈 값인 전체라는 항목 추가 여부
        *  callback     : 콜백 함수
        *  fltrVal      : 조회 조건
        *  isWithName   : 리턴되는 코드 명을 코드와 명을 '|' 로 합침
        *  useYn        : 코드의 사용 여부 조회 조건
        */ 
        getCmonCdList: function(cdGrp, arrayObject, allAddYn, callback, fltrVal, isWithName, useYn) {
            let cmonCdList = SessionUtil.getCmonCdList();
            console.log('getComm')
            var dataList = cmonCdList['cmonCdList'].filter(el => el.cdGrp === cdGrp);
            if (Array.isArray(arrayObject)) {
                if(WebUtil.isNotNull(useYn)){
                    dataList = dataList.filter(el => el.useYn === useYn);
                }
                if(WebUtil.isNotNull(fltrVal)){
                    var fltrVal1 = fltrVal.fltrVal1;
                    var fltrVal2 = fltrVal.fltrVal2;
                    var fltrVal3 = fltrVal.fltrVal3;
                    if(WebUtil.isNotNull(fltrVal1)){
                        dataList = dataList.filter(el => el.fltrVal1 === fltrVal1);
                    }
                    if(WebUtil.isNotNull(fltrVal2)){
                        dataList = dataList.filter(el => el.fltrVal2 === fltrVal2);
                    }

                    if(WebUtil.isNotNull(fltrVal3)){
                        dataList = dataList.filter(el => el.fltrVal3 === fltrVal3);
                    }
                }

                let m = 0;
                const dataCnt = dataList.length;
                if (isWithName) {
                    for (m = 0; m < dataCnt; m++) {
                        arrayObject.push({
                            cdVal   : dataList[m].cdVal, 
                            cdNm    : dataList[m].cdVal + ' | ' + dataList[m].cdNm,
                            sortOrd : dataList[m].sortOrd
                        });
                    }
                } else {
                    for (m = 0; m < dataCnt; m++) {
                        arrayObject.push({
                            cdVal   : dataList[m].cdVal, 
                            cdNm    : dataList[m].cdNm,
                            sortOrd : dataList[m].sortOrd
                        });
                    }
                }

                if (allAddYn === 'Y') {
                    arrayObject.unshift({cdVal:'', cdNm:''});
                }
            }
            if (typeof callback === "function") {
                callback(dataList);
            }
            return arrayObject;
        },
        // doPost: function(opt) {
        //     // let $this = this;

        //     // $this.$store.commit(types.SHOW_LOADING, true);

        //     // setTimeout(function() {
        //     //     console.log('timer');
        //     //     $this.$store.commit(types.SHOW_LOADING, false);

        //     // }, 1000);
        //     AjaxUtil.post(opt);
        // },
        // doGet: function(opt) {
        //     AjaxUtil.get(opt);
        // },

        doGet: function(url, data, isLoading) {
            if ( isLoading == undefined ) {
                isLoading = true;
            }
            
            const header = {
                '__isLoading__': !!isLoading
            }

            const param = {
                params : data
            }

            return AxiosUtil.get(url, param, header);
        },

        doPost: function(url, data, isLoading) {
            if ( isLoading == undefined ) {
                isLoading = true;
            }
            
            const header = {
                '__isLoading__': !!isLoading
            }
            
            return AxiosUtil.post(url, data, header);
        },

        doPatch: function(url, data, isLoading) {
            if ( isLoading == undefined ) {
                isLoading = true;
            }
            
            const header = {
                '__isLoading__': !!isLoading
            }

            return AxiosUtil.patch(url, data, header);
        },

        doDelete: function(url, param, isLoading) {
            if ( isLoading == undefined ) {
                isLoading = true;
            }
            
            const header = {
                '__isLoading__': !!isLoading
            }

            const params = {
                data : param
            }

            return AxiosUtil.delete(url, params, header);
        },

        async doGetSync (url, data) {
            // url = '127.0.0.1:8080'+url
            return await AxiosUtil.get(url, data);
        },

        async doPostSync (url, data) {
            // url = '127.0.0.1:8080'+url
            return await AxiosUtil.post(url, data);
        },

        doPostForm: function(url, data) {
            return AxiosUtil.postForm(url, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }});
        },

        alert: function(opt) {
            let title   = '알림';
            let content = '';

            if ( WebUtil.isNotNull(opt) ) {

                if ( typeof opt === 'object' ) {
                    if ( WebUtil.isNotNull(opt.title) ) {
                        title = opt.title;
                    }

                    if ( WebUtil.isNotNull(opt.content) ) {
                        content = opt.content;
                    }
                }
                else
                {
                    content = opt;
                }
            }

            // if ( WebUtil.isNotNull(content) ) {
            //     this.$store.commit(types.ALERT_TITLE  , title);
            //     this.$store.commit(types.ALERT_CONTENT, content);
            //     this.$store.commit(types.ALERT_DIALOG , true);
            // } else {
            //     console.log('내용을 넣어주세요.');
            // }

            if (WebUtil.isNotNull(content)) {
                let option = {
                    title: title,
                    confirmButtonText: '확인',
                    confirmButtonColor: '#0099d8',
                    cancelButtonColor: '#5a5b5b',
                    cancelButtonText: '취소',
                    html: content
                };

                // SweetAlert2의 Promise 반환
                return this.$swal(option);
            } else {
                console.log('내용이 없습니다.');
                return Promise.reject('내용이 없습니다.');
            }
        },
        confirm: function(opt) {

            let $this = this;
            
            let title       = '확인창';
            let content     = '';
            let yesText     = '확인';
            let noText      = '취소';
            let yesVisible  = true;
            let noVisible   = true;
            let yesCallback = null;
            let noCallback  = null;

            if ( WebUtil.isNotNull(opt) ) {

                if ( typeof opt === 'object' ) {
                    if ( WebUtil.isNotNull(opt.title) ) {
                        title = opt.title;
                    }

                    if ( WebUtil.isNotNull(opt.content) ) {
                        content = opt.content;
                    }
                }
                else
                {
                    content = opt;
                }

                if ( opt.btn )
                {
                    if ( WebUtil.isNotNull(opt.btn.yes) ) {
                        yesText = WebUtil.nvl(opt.btn.yes, yesText);
                    }
                    if ( WebUtil.isNotNull(opt.btn.no) ) {
                        noText = WebUtil.nvl(opt.btn.no, noText);
                    }
                }

                if ( opt.visible )
                {
                    if ( WebUtil.isNotNull(opt.visible.yes) ) {
                        yesVisible = WebUtil.nvl(opt.visible.yes, yesVisible);
                    }
                    if ( WebUtil.isNotNull(opt.visible.no) ) {
                        noVisible = WebUtil.nvl(opt.visible.no, noVisible);
                    }
                }

                if ( opt.callback )
                {
                    if ( WebUtil.isNotNull(opt.callback.yes) ) {
                        yesCallback = opt.callback.yes;
                    }

                    if ( WebUtil.isNotNull(opt.callback.no) ) {
                        noCallback = opt.callback.no;
                    }
                }
            }

            // let res;
            if ( WebUtil.isNotNull(content) ) {
                $this.$store.commit(types.CONFIRM_TITLE        , title);
                $this.$store.commit(types.CONFIRM_CONTENT      , content);
                $this.$store.commit(types.CONFIRM_YES_TEXT     , yesText);
                $this.$store.commit(types.CONFIRM_NO_TEXT      , noText);
                $this.$store.commit(types.CONFIRM_YES_VISIBLE  , yesVisible);
                $this.$store.commit(types.CONFIRM_NO_VISIBLE   , noVisible);
                $this.$store.commit(types.CONFIRM_YES_CALLBACK , yesCallback);
                $this.$store.commit(types.CONFIRM_NO_CALLBACK  , noCallback);
                $this.$store.commit(types.CONFIRM_DIALOG       , true);
                
            } else {
                console.log('내용을 넣어주세요.');
               
            }
        },
        openWindowPopup: function(url) {
            if ( WebUtil.isNull(url) ) {
                this.alert('경로가 없습니다.');
            } else {
                window.open(url);
            }
        },
        formatDate: function(val) {
            return DateUtil.getFormatDate(val);
        },
        formatTime: function(val) {
            return DateUtil.getFormatTime(val);
        },
        formatDateTime: function(val) {
            return DateUtil.getFormatDateTime(val);
        },
        getGPSValue: function(val) {
            return Number(val).toFixed(7);
        },
        setActiveScrn: function(scrnDiv) {
            this.$store.commit(types.SCRN_DIV, scrnDiv);
        },
        getActiveScrn: function() {
            return this.$store.getters.scrnDiv;
        },
        getSelectedChild: function() {
            return this.$store.getters.selectedChild;
        },
        setDetlMenu: function() {
            // this.emitter.emit('onChangeMainMenu', false);
        },
        setMainMenu: function() {
            // this.emitter.emit('onChangeMainMenu', true);
        },
        showChildren: function() {
            this.emitter.emit('onChangeVisibleChild', true);
        },
        hideChildren: function(pageTitle) {
            // this.$store.commit(types.PAGE_TITLE, pageTitle);
            // this.emitter.emit('onChangeVisibleChild', false);
        },
        // 상단 메뉴 페이지 타이틀 세팅
        setPageDiv: function(pageDiv){
            this.$store.commit(types.PAGE_DIV, pageDiv);
        },
        // 상단 왼쪽 메뉴 세팅
        setPageLeftDiv: function(pageLeftDiv){
            this.$store.commit(types.PAGE_LEFT_DIV, pageLeftDiv);
        },
        // 상단 중간 메뉴 세팅
        setPageMidDiv: function(pageMidDiv){
            this.$store.commit(types.PAGE_MID_DIV, pageMidDiv);
        },
        // 상단 오른쪽 메뉴 세팅
        setPageRightDiv: function(pageRightDiv){
            this.$store.commit(types.PAGE_RIGHT_DIV, pageRightDiv);
        },
        // 상단 메뉴 페이지 타이틀 세팅
        setPageTitle: function(pageTitle){
            this.$store.commit(types.PAGE_TITLE, pageTitle);
        },
        // 상단 메뉴 서브페이지 타이틀 세팅
        setSubPageTitle: function(subPageTitle){
            if(WebUtil.isNotNull(subPageTitle)){
                this.$store.commit(types.SUB_PAGE_TITLE, subPageTitle);
            }
        },
        // 상단 메뉴 라우터 동작 여부
        setTopMenuRouter(routerDiv, routerVal){
            this.$store.commit(types.ROUTER_DIV , routerDiv);
            this.$store.commit(types.ROUTER_VAL , routerVal);
        },
        
        /* ** baseMixins의 상단 메뉴 전체 세팅 데이터 불러오기 
            1) pageLeftDiv : 상단 메뉴 좌측 세팅
                - logo       : 로고
                - back       : 뒤로가기
                - menu       : 사이드 바 메뉴
            2) pageMidDiv    : 상단 메뉴 중간 세팅
                - pgNmSub    : 페이지명 + 서브타이틀
                - pgNmOnly   : 페이지명만
                - logoSub    : 로고 + 서브타이틀
            3) pageRightDiv  : 상단 메뉴 우측 세팅
                - logo       : 로고
                - myPage     : 메인화면에서의 myPage
                - none       : 없음
            4) pageTitle     : 페이지의 타이틀
            5) subPageTitle  : 페이지의 서브 타이틀
            -- 6 / 7 번은 기본 동작 이외에 필요 시 사용합니다.
            6) routerDiv     : 상단 메뉴 라우터 기능 구분
              - 동작 구분    : 지정 하지 않을 시 빈값 (push / replace / go / back)
            7) routerVal     : Router 경로 및 동작 구분 
              - { mloc:'', rloc :'', param:''} 형태로 데이터 전달
                - mloc   : left / mid / right
                - rloc   : 이동 할 router 경로
                - params : 이동 시 전달 할 파라미터 
                ex) {mloc: 'left' , rloc : 'Home' ,params: this.info}
                왼쪽메뉴를 누르면 router.push 로 Home 으로 이동 this.info 값을 전달
        */
        setTopMenu: function(pageLeftDiv, pageMidDiv, pageRightDiv , pageTitle, subPageTitle, routerDiv, routerVal){
            const $this = this;
            $this.setPageLeftDiv(pageLeftDiv);
            $this.setPageMidDiv(pageMidDiv);
            $this.setPageRightDiv(pageRightDiv);
            $this.setPageTitle(pageTitle);
            $this.setSubPageTitle(subPageTitle);
            
            if(WebUtil.isNotNull(routerDiv) && WebUtil.isNotNull(routerVal)){
                $this.setTopMenuRouter(routerDiv, routerVal);
            } else {
                // 초기화 해주지 않으면 이전에 저장한 값이 계속 사용되어 문제 발생함
                $this.setTopMenuRouter('', '');
            }
            
            //페이지 변경 이벤트 발생
            $this.emitter.emit('onChangeTopMenu', true);
        },
        // 상단 왼쪽 메뉴 구분 가져오기
        getPageLeftDiv:function(){
            return this.$store.getters.pageLeftDiv;
        },
        // 상단 중간 메뉴 구분 가져오기
        getPageMidDiv:function(){
            return this.$store.getters.pageMidDiv;
        },
        // 상단 오른쪽 메뉴 구분 가져오기
        getPageRightDiv:function(){
            return this.$store.getters.pageRightDiv;
        },
        // 상단 메뉴 페이지타이틀 구분 가져오기
        getPageTitle: function(){
            return this.$store.getters.pageTitle;
        },
        // 상단 메뉴 서브페이지타이틀 구분 가져오기
        getSubPageTitle: function(){
            return this.$store.getters.subPageTitle;
        },
         // 상단 메뉴 라우터 기능 구분 가져오기
         getRouterDiv: function(){
            return this.$store.getters.routerDiv;
        },
        // 상단 메뉴 라우터 파라미터  가져오기
        getRouterVal: function(){
            return this.$store.getters.routerVal;
        },
        /* 라우터 설정 함수  / 김범수
        *  path : router 폴더 내 정의 된   name: 'nm',
        *  param : 라우터로 화면 이동 시 전달할 파라미터
        *  routerDiv : push / go / back  구분
        *              기본값 push
        *  go 일시 path에 숫자 입력
        **/ 
        setRouter(path, params, routerDiv ){
            const $this = this;
            let routerAct = '';
            // 현재 등록된 라우트 목록 가져오기
            const routeExists = $this.$router.getRoutes().some(route => route.name === path);

            const userRole = SessionUtil.getUserRoleList();

            if (path === 'SchdStat') {
                if (!userRole.some(role => role.roleCd === "SCHD_USER")) {
                    $this.alert("일정사용자 권한을 가진 사용자만 이용할 수 있습니다.");
                    return false;
                }
            }

            if(!routeExists){
                $this.alert('향후 지원 예정입니다.');
                return false;
            }
            if (WebUtil.isNull(path)) {
                $this.alert('경로가 지정되지 않았습니다.');
            }
            if(WebUtil.isNull(routerDiv)){
                routerAct = 'push';
            } else {
                routerAct = routerDiv;
            }
            SessionUtil.setLocalStorageData(path, params, false);
            if(routerAct === 'push'){
                $this.$router.push({name : path});
            } else if(routerAct === 'go'){
                let pathInt = parseInt(path);
                if(!isNaN(pathInt) && Number.isInteger(Number(pathInt))){
                    $this.alert("올바른 동작이 아닙니다.");
                    return false;
                }
                $this.$router.go(pathInt);
            } else if(routerAct === 'back'){
                $this.$router.back();
            } else if(routerAct ==='replace'){
                $this.$router.replace({name:path});
            } 
            
            else {
                $this.alert('올바른 동작이 아닙니다.');
                return false;
            }
        },
        /* 라우터 파라미터 리턴 함수 / 김범수
        *  path : router 폴더 내 정의 된   name: 'nm'
                  setRouter에서 선언한 path
        **/ 
        getRouter(path) { 
            const $this = this;
            let params = '';
            // 현재 등록된 라우트 목록 가져오기
            const routeExists = $this.$router.getRoutes().some(route => route.name === path);
            if (WebUtil.isNull(routeExists)) {
                return null;
            }
            if(WebUtil.isNotNull(path)){
                let getParam = SessionUtil.getLocalStorageData(path,false);
                
                if(WebUtil.isNotNull(getParam)){
                    params = _.cloneDeep(getParam);
                } else {
                    params = '';
                }
                SessionUtil.removeLocalStorageData(path);
            } else {
                CmonUtil.alert("페이지 이동 도중 오류가 발생하였습니다.");
            }
            return params;
        },
        thousandComma: function(val) {
            let str = ''
            if(WebUtil.isNotNull(val)){
                str = WebUtil.addThousandComma(val);
            }
            return str;
        },
    },
    computed: {
        // isOpen() {
        //     if ( this.$store.getters.alertDialog ) {
        //         this.$refs.baseModal.open();
        //     }       
        // },
        
    },
    beforeCreate: function() {
        // console.log(":::::::: mixin beforeCreate ::::::::");
        // 로그인 사용자 정보 쿠키로부터 얻기
    },
    created: function(){
        //console.log(":::::::: mixin created ::::::::");
    },
    beforeMount: function(){
        // console.log(":::::::: mixin beforeMount ::::::::");
        // this.setMainMenu();
        // this.hideChildren();
    },
    mounted: function(){
        //console.log(":::::::: mixin mounted ::::::::");
    },
    beforeUpdate: function(){
        //console.log(":::::::: mixin beforeUpdate ::::::::");
    },
    updated: function(){
        //console.log(":::::::: mixin updated ::::::::");
    },
    beforeDestroy: function(){
        // console.log(":::::::: mixin beforeDestroy ::::::::");
        // this.setMainMenu();
        // this.hideChildren();
    },
    destroyed: function(){
        //console.log(":::::::: mixin destroyed ::::::::");
    }
}

export default baseMixins
</script>